import { Component, OnInit, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { AppDataService } from '../../core/services/app-data.service';
import { ReportService } from '../../core/services/report.service';
import { ExportService } from '../../core/services/export.service';
import { EquipmentService } from '../../core/services/equipment.service';
import { formatDate } from '../../core/utils/format.util';
import { environment } from '../../environments/environment';
import { ReportDateRangeComponent } from '../report-date-range/report-date-range.component';
import { ReportDateRangeService } from '../../report-date-range.service';

@Component({
  selector: 'app-checked-out-equipment-report',
  standalone: true,
  imports: [RouterLink, ReportDateRangeComponent],
  templateUrl: './checked-out-equipment.component.html',
  styleUrl: '../../report-shared.css',
})
export class CheckedOutEquipmentReportComponent implements OnInit {
  private readonly appData = inject(AppDataService);
  private readonly reports = inject(ReportService);
  private readonly equipment = inject(EquipmentService);
  private readonly exporter = inject(ExportService);
  protected readonly dateRange = inject(ReportDateRangeService);
  protected readonly formatDate = formatDate;

  private readonly range = computed(() => ({
    startDate: this.dateRange.appliedStartDate(),
    endDate: this.dateRange.appliedEndDate(),
  }));

  protected readonly checkouts = computed(() =>
    this.reports.getCheckedOutEquipmentReport(this.range()),
  );

  ngOnInit(): void {
    if (!environment.useMockData) {
      this.appData.refreshAll();
    }
  }

  protected isOverdue(dueDate: string, status: string): boolean {
    return (
      status === 'overdue' || dueDate < new Date().toISOString().slice(0, 10)
    );
  }

  exportData(): void {
    this.exporter.downloadCsv(
      `checked-out-equipment-${new Date().toISOString().slice(0, 10)}`,
      this.checkouts().map((row) => ({ ...row })),
    );
  }
}
